<div class="content-wrapper">
  <section class="content">
    <div class="container-fluid" style="padding: 20px 0">

      <div class="row">

        <div class="col-md-7">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">
                <i class="fas fa-text-width"></i>
                Manage Users
              </h3>
            </div>
            <div class="card-body table-responsive p-0" style="height: 400px;">
              <table class="table table-head-fixed text-nowrap">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of users">
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.role }}</td>
                    <td>
                      <a class="btn" (click)="edit(user)"><i class="fas fa-edit"></i></a>
                      <a class="btn" (click)="password(user)"><i class="fas fa-key"></i></a>
                      <a class="btn" (click)="delete(user)"
                      *ngIf="user._id !== currentUser._id">
                      <i class="fas fa-trash"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>




        <div class="col-md-5" *ngIf="!editFlag && !passwordFlag">
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Create a new user</h3>
            </div>
            <form [formGroup]="userForm" (ngSubmit)="onSubmit();">
              <div class="card-body">
                <div class="form-group">
                  <label for="exampleInputEmail1">Name</label>
                  <input type="email" class="form-control" placeholder="name" formControlName="name">
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Email address</label>
                  <input type="email" class="form-control" placeholder="Enter email" formControlName="email">
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="role">Role</label>
                    <select class="form-control custom-select" name="type" id="role" formControlName="role">
                      <option value="" selected disabled>Select a role</option>
                      <option value="dataentry">dataentry</option>
                      <option value="sales">sales</option>
                      <option value="manager">manager</option>
                      <option value="account">account</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="exampleInputPassword1">Password</label>
                    <input type="text" class="form-control" placeholder="Password" formControlName="password">
                    <p style="color: grey; font-size: 14px; padding: 2px; margin: 0;">Minimun 8 digit
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-footer" style="text-align: center;">
                <button type="submit" class="btn btn-primary"  *ngIf="!loading">Create User</button>
                <button class="btn btn-primary" type="button" disabled *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Creating...
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-5" *ngIf="passwordFlag">
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Update Password</h3>
            </div>
            <form [formGroup]="updatePasswordForm" (ngSubmit)="onPassword();">
              <div class="card-body">
                <div class="form-group">
                  <label for="exampleInputPassword1">Password</label>
                    <input type="text" class="form-control" placeholder="Password" formControlName="password">
                    <p style="color: grey; font-size: 14px; padding: 2px; margin: 0;">Minimun 8 digit
                    </p>
                </div>
              </div>
              <div class="card-footer" style="text-align: center;">
                <button type="button" class="btn btn-secondary mx-2"  *ngIf="!loading" (click)="cancel()">cancel</button>
                <button type="submit" class="btn btn-primary"  *ngIf="!loading">Update Password</button>
                <button class="btn btn-primary" type="button" disabled *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Updating...
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-5" *ngIf="editFlag && !passwordFlag">
          <div class="card card-primary">
            <div class="card-header">
              <h3 class="card-title">Update user</h3>
            </div>
            <form [formGroup]="updateUserForm" (ngSubmit)="onUpdate();">
              <div class="card-body">
                <div class="form-group">
                  <label for="exampleInputEmail1">Name</label>
                  <input type="email" class="form-control" placeholder="name" formControlName="name">
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Email address</label>
                  <input type="email" class="form-control" placeholder="Enter email" formControlName="email">
                </div>
                <div class="form-group">
                  <label for="role">Role</label>
                  <select class="form-control custom-select" name="type" id="role" formControlName="role">
                    <option value="" selected disabled>Select a role</option>
                    <option value="dataentry">dataentry</option>
                    <option value="sales">sales</option>
                    <option value="manager">manager</option>
                    <option value="account">account</option>
                  </select>
                </div>
              </div>
              <div class="card-footer" style="text-align: center;">
                <button type="button" class="btn btn-secondary mx-2"  *ngIf="!loading" (click)="cancel()">cancel</button>
                <button type="submit" class="btn btn-primary"  *ngIf="!loading">Update User</button>
                <button class="btn btn-primary" type="button" disabled *ngIf="loading">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Updating...
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>

    </div>
  </section>
</div>
